import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { hydrate, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import AppToaster from './components/AppToaster';
import { queryClient } from './lib/queryClient';
import App from './App';
import './index.css';

// Public pages arrive pre-rendered (scripts/prerender.mjs) with the data they
// showed; reuse both so the page doesn't flash or fetch again.
if (window.__MDU_QUERY_STATE__) {
  hydrate(queryClient, window.__MDU_QUERY_STATE__);
  delete window.__MDU_QUERY_STATE__;
}
const container = document.getElementById('root');
const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
      <AppToaster />
    </QueryClientProvider>
  </StrictMode>
);

// The pre-rendered HTML is the page without filters (e.g. /blog, not
// /blog?page=2), so filtered addresses draw fresh instead of hydrating.
const filtered = [...new URLSearchParams(window.location.search).keys()].some(
  (key) => !key.startsWith('utm_'),
);
if (container.dataset.prerendered === 'true' && !filtered) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
